
import { SimulationConfig } from '@/types';
import { BackgroundRegistry } from './background/BackgroundRegistry';
import { initializeBackgroundRegistry } from './background/RegistryInitializer';

export class BackgroundRenderer {
  private static initialized = false;

  private static init() {
    if (this.initialized) return;
    initializeBackgroundRegistry();
    this.initialized = true;
  }

  public static draw(
    ctx: CanvasRenderingContext2D,
    config: SimulationConfig,
    width: number,
    height: number,
    globalHue: number
  ) {
    if (!config.backgroundEnabled) {
        // Fallback clear
        ctx.fillStyle = config.darkMode ? '#000000' : '#ffffff';
        ctx.fillRect(0, 0, width, height);
        return;
    }
    
    this.init();

    const time = Date.now() * 0.001;

    ctx.save();
    
    // Apply global background filters
    if (config.backgroundBrightness !== 1 || config.backgroundContrast !== 1 || config.backgroundSaturation !== 1) {
        ctx.filter = `brightness(${config.backgroundBrightness}) contrast(${config.backgroundContrast}) saturate(${config.backgroundSaturation})`;
    }

    BackgroundRegistry.render(config.backgroundEffect, {
        ctx,
        config,
        width,
        height,
        time,
        globalHue
    });

    ctx.restore();
  }
}
